import * as api from "../../shared/api";
import * as biz_data_helper from "../../shared/biz_data_helper";
import * as _date from "date-fns";

const content_type = "ExchangeRate";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};

const descriptor = {};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);

const fields = [
  { key: "RecId", label: "汇率编号", sortable: true, thStyle: { width: "80px" } },
  { key: "dispFromCurrencyCode", label: "原币代码", sortable: true },
  { key: "dispToCurrencyCode", label: "目标币种", sortable: true },
  {
    key: "ValidFrom",
    label: "开始日期",
    type: "date"
  },
  {
    key: "ValidTo",
    label: "结束日期",
    type: "date"
  }, {
    key: "ExchangeRate",
    label: "汇率",
    type: "number",
    _precise: 4
  }, {
    key: "modifiedDateTime",
    label: "修改日期和时间",
    type: "datetime"
  }
];

const dataForm = {};
///前端验证
const rules = {};

const methods = {
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields, "key")
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  //单独获取汇率
  async getExchRate(_params) {
    const ec_biz_data = new biz_data_helper.base_entity_helper(
      "get_exchange_rate",
      {},
      {}
    );
    let result = await ec_biz_data
      .execAction({
        params: {
          "fCur": _params.fCur,
          "tCur": _params.tCur
        },
        fields: [
          "exchange_rate"
        ],
      })
      .run();
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
};
export { fields, dataForm, methods, rules, biz_data };
